import {Component, Input, OnInit} from '@angular/core';
import {RequeteDetail} from '../../entities/requete';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-dossier-modal',
    template: `
          <ng-container [ngSwitch]="requete?.statut.toString()">
            <div aria-modal="true"
                 role="alertdialog"
                 aria-labelledby="alert_dialog_attach_doc_label"
                 aria-describedby="alert_dialog_attach_doc_desc"
                 jhiTrapFocus>
              <div class="modal-header m-4">
                <h4 class="modal-title" *ngSwitchCase="'En attente de rattachement'" id="alert_dialog_attach_doc_label">
                  Ce dossier est en cours de rattachement
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                  <span aria-hidden="true" title="Fermer la fenêtre">&times;</span>
                  <span class="sr-only">Fermer la fenêtre</span>
                </button>
              </div>

              <div class="modal-body m-4" *ngSwitchCase="'En attente de rattachement'">
                <p>Vous avez fait les démarches nécessaires pour avoir accès à ce dossier.</p>
                <p id="alert_dialog_attach_doc_desc">La procédure de rattachement sera finalisée d'ici 24 heures au plus tard.
                Vous recevrez un courriel d'avertissement dès l'opération finalisée,
                et vous pourrez accéder à ce dossier depuis cette page d'accueil.
                </p>
              </div>

              <div class="modal-footer">
                  <button class="btn btn-outline-primary m-auto" (click)="activeModal.dismiss('Cross click')">Fermer</button>
              </div>
            </div>
          </ng-container>
      `
})
export class DossierModalComponent implements OnInit {

    @Input() requete: RequeteDetail;


    constructor(
        public activeModal: NgbActiveModal
    ) {
    }

    ngOnInit(): void {
        // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Ce dossier est en cours de rattachement');
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/mes-dossiers/dossier-modal-component.ts